import { selectUserProjectTimeZone } from 'core/userContext';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch, useSelector } from 'react-redux';
import { useScheduleCampaignMutation } from '../../../lib/hooks/useScheduleCampaignMutation';
import { ModalType, useCampaignContext, useModalContext } from '../../context';
import { useGenerateCampaignAlerts } from '../../hooks';
import { maybeRestErrorMessage } from '../../utils';
import { getSendCampaignPayload } from './SendCampaignModal.utils';

export const useSendCampaign = () => {
  const { closeModal } = useModalContext();
  const { campaign, refetch: refetchCampaign } = useCampaignContext();
  const { isLoading, error, mutate } = useScheduleCampaignMutation();
  const { generateCampaignAlerts } = useGenerateCampaignAlerts();
  const { name, id, campaignAlertsEnabled } = campaign;

  const dispatch = useDispatch();
  const projectTimeZone = useSelector(selectUserProjectTimeZone);

  const sendCampaign = () => {
    const onSuccess = () => {
      dispatch(addPositiveToast(`${name} scheduled successfully.`));
      generateCampaignAlerts({ campaignAlertsEnabled, id });
      closeModal(ModalType.SendCampaign);
      refetchCampaign();
    };

    const onError = (e: unknown) => {
      const errorResponseMessage = maybeRestErrorMessage(e);
      const defaultErrorMessage = 'Error scheduling campaign: something went wrong.';
      const errorMessage = errorResponseMessage || defaultErrorMessage;
      dispatch(addNegativeToastWithErrorId(errorMessage, 'sendCampaign', e));

      closeModal(ModalType.SendCampaign);
    };

    const payload = getSendCampaignPayload(campaign, projectTimeZone);

    mutate(payload, {
      onSuccess,
      onError,
    });
  };

  return { isLoading, error, sendCampaign };
};
